// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ayJ4Q","form":"styles_form__AuMtx"};